export const billing = {
  title: `<b>Top up</b> your balance<br /> to {{title}} more.`,
  titleNoMoney: '<b>Out of coins</b><br /> Top up your balance',
  confirmation: {
    title: 'Confirm your choice',
    packageDescription:
      'You will continue your purchase in the payment system.',
    submitButton: 'Confirm purchase',
  },
  failedMessage: 'Transaction failed',
  successMessage: 'All good. You deposited {amount}',
  cancelPurchase: {
    title: 'Cancel coins purchase',
    description: 'Are you sure you want to cancel coins purchasing?',
    applyText: 'Yes',
    rejectText: 'No',
  },
  balance: {
    title: 'Balance',
    bonus: 'Bonus',
    add: 'Add',
    withdrawal: 'Withdrawal',
    promocode: 'Promo code',
    loadingBalance: 'Loading balance',
    loadingBonus: 'Loading bonus balance',
    paymentHistory: 'Payment history',
    headers: {
      date: 'Date',
      amount: 'Amount',
      type: 'Type',
      status: 'Status',
    },
    empty: 'No payments found',
    loading: 'Loading payments...',
    loadingMore: 'Loading more payments...',
    loadFailed: 'Unable to load payment history',
    loadMoreFailed: 'Unable to load more payment history',
    taskType: {
      coinsPurchase: 'Coins purchase',
      subscriptionPurchase: 'Subscription',
      cryptoDeposit: 'Crypto deposit',
      cryptoWithdraw: 'Crypto withdraw',
      paypalDeposit: 'PayPal deposit',
      cardDeposit: 'Card deposit',
      paypalWithdraw: 'PayPal withdraw',
    },
    taskStatus: {
      created: 'Created',
      pending: 'Pending',
      completed: 'Completed',
      failed: 'Failed',
      finished: 'Finished',
      canceled: 'Canceled',
      error: 'Error',
    },
  },
  deposit: {
    ageRestrictionTitle: 'Age Restriction',
    ageRestrictionText: 'Deposit is not available because of age restriction.',
    firstDepositBonusTitle: 'First deposit bonus',
    firstDepositBonusText:
      'Get a <primary>$5 bonus</primary> on your first deposit',
    title: 'Deposit',
    choosePaymentType: 'Choose payment type',
    paypal: 'PayPal',
    crypto: 'Crypto',
    card: 'Card',
    googlePay: 'Google Pay',
    applePay: 'Apple Pay',
    amazonPay: 'Amazon Pay',
    weChatPay: 'WeChat Pay',
    amountUsd: 'Amount (USD)',
    amountUsdt: 'Amount (USDT)',
    enterAmount: 'Enter amount',
    minimumAmountNote: 'Minimum deposit: {{amount}}',
    totalWithFee: 'Total with service fee (USD)',
    totalFeeNote: 'This is the total amount, including the service fee.',
    network: 'Network',
    createPaypalDeposit: 'Create PayPal deposit',
    createCryptoDeposit: 'Create crypto deposit',
    createCardDeposit: 'Create card deposit',
    cardDetailsTitle: 'Card details',
    billingDetailsTitle: 'Billing details',
    billingDetailsSavedSummary: '{{firstName}} {{lastName}} · {{country}}',
    cardNumber: 'Card number',
    cardNumberPlaceholder: '4111 1111 1111 1111',
    cardExpiry: 'Expiry date',
    cardExpMonthPlaceholder: 'MM',
    cardExpYearPlaceholder: 'YY',
    cardCvv: 'Code',
    cardCvvPlaceholder: 'CVC',
    firstName: 'First name',
    lastName: 'Last name',
    phone: 'Phone',
    address: 'Address',
    city: 'City',
    state: 'State / region',
    country: 'Country',
    countrySearchPlaceholder: 'Search country',
    countryListLabel: 'Countries',
    countryNoResults: 'No countries found',
    phoneNationalPlaceholder: '2063582043',
    phoneCodeSearchPlaceholder: 'Search code or country',
    phoneCodeListLabel: 'Phone country codes',
    zipCode: 'ZIP / postal code',
    cardManualContinue:
      'If redirect did not happen, continue card authentication manually:',
    openCardAuthentication: 'Open card authentication page',
    createGooglePayDeposit: 'Continue with Google Pay',
    createApplePayDeposit: 'Continue with Apple Pay',
    createAmazonPayDeposit: 'Continue with Amazon Pay',
    createWeChatPayDeposit: 'Continue with WeChat Pay',
    dodoManualContinue:
      'If redirect did not happen, continue card checkout manually:',
    openDodoCheckout: 'Open checkout page',
    paypalManualContinue:
      'If redirect did not happen, continue PayPal approval manually:',
    openPaypalApproval: 'Open PayPal approval page',
    cryptoManualContinue:
      'If redirect did not happen, continue payment manually:',
    openPaymentPage: 'Open payment page',
    processingTitle: 'Processing PayPal payment',
    processingText: 'Processing PayPal payment...',
    toast: {
      amountPositive: 'Amount must be a positive number',
      minimumAmount: 'Minimum deposit amount is {{amount}}',
      depositLinkMissing:
        'Deposit task created, but payment link was not returned',
      depositCreated: 'Deposit task created. Redirecting to payment...',
      paypalLinkMissing:
        'PayPal task created, but approval link was not returned',
      paypalCreated: 'PayPal task created. Redirecting to approval...',
      paypalTokenMissing: 'PayPal token was not returned',
      paypalCaptureFailed: 'Failed to capture PayPal payment',
      unsupportedCardType: 'Only Visa and Mastercard are supported',
      invalidCardExpiryMonth: 'Enter a valid expiry month (01–12)',
      invalidCardExpiryYear: 'Enter a 2-digit expiry year',
      invalidCardNumber: 'Invalid card number',
      cardDepositCompleted: 'Card deposit completed successfully',
      cardDepositProcessing:
        'Payment is being processed. Your balance will update shortly.',
    },
  },
  promocode: {
    title: 'Promo code',
    description: 'Apply a promo code to receive bonus coins',
    codeLabel: 'Promo code',
    codePlaceholder: 'Enter promo code',
    submit: 'Apply',
    codeRequired: 'Enter a promo code',
    success: 'Promo code applied. You received {{amount}} bonus.',
  },
  withdrawal: {
    securityRequirements: 'Security Requirements',
    ageRestrictedTitle: 'Withdrawals are unavailable due to age restriction.',
    ageRestrictedHint: 'You must be at least {{age}} years old.',
    mfaRequiredTitle: 'Withdrawals are available only with enabled 2FA.',
    mfaRequiredHint:
      'Enable two-factor authentication to protect your funds and complete withdrawal securely.',
    enable2fa: 'Enable 2FA',
    kycRequiredTitle: 'Identity Verification Required',
    kycPending: 'Verification in progress. Complete Veriff and refresh status.',
    kycResubmission:
      'Veriff requested another submission. Continue verification and refresh status.',
    kycRequired: 'Withdrawals require identity verification.',
    startKyc: 'Start KYC',
    continueKyc: 'Continue KYC',
    refreshStatus: 'Refresh Status',
    paypalTitle: 'PayPal withdrawal',
    paypalIntro:
      'Request a payout to your PayPal account by entering the amount, your PayPal email, and your 2FA code.',
    amountUsd: 'Amount (USD)',
    paypalEmail: 'PayPal email',
    paypalEmailPlaceholder: 'name@example.com',
    tfaCode: '2FA code',
    tfaCodePlaceholder: 'Enter 2FA code',
    requestPaypalPayout: 'Request PayPal payout',
    cryptoTitle: 'Withdrawal crypto',
    amountUsdt: 'Amount (USDT)',
    network: 'Network',
    address: 'Address',
    addressPlaceholder: 'Enter USDT address',
    createCryptoWithdraw: 'Create crypto withdraw',
    payoutNotice:
      'We are actively working to facilitate payouts to debit cards or bank accounts as quickly as possible. We apologize for any inconvenience this may cause and extend our best wishes for a competitive experience.',
    toast: {
      amountPositive: 'Amount must be a positive number',
      withdrawCreated: 'Withdraw task created',
      paypalPayoutCreated: 'PayPal payout request created',
    },
  },
  error: {
    requestFailed: 'Request failed',
    kycRequired: 'Withdrawals require identity verification.',
    kycPending: 'Verification is still in progress.',
    kycResubmission: 'Veriff needs another document submission.',
    withdrawAcquirerFailed:
      'Withdrawal service is temporarily unavailable. Your reserved balance was refunded.',
  },
};
